/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerUpdateMutationRequest, PotentialChangeOrdersControllerUpdateMutationResponse, PotentialChangeOrdersControllerUpdatePathParams, PotentialChangeOrdersControllerUpdate400, PotentialChangeOrdersControllerUpdate401, PotentialChangeOrdersControllerUpdate403, PotentialChangeOrdersControllerUpdate404 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerUpdate";

function getPotentialChangeOrdersControllerUpdateUrl(id: PotentialChangeOrdersControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/potential-change-orders/${id}` as const }  
  return res
}

/**
 * @summary Update a potential change order (status transition)
 * {@link /api/v1/potential-change-orders/:id}
 */
export async function potentialChangeOrdersControllerUpdate(id: PotentialChangeOrdersControllerUpdatePathParams["id"], data?: PotentialChangeOrdersControllerUpdateMutationRequest, config: Partial<RequestConfig<PotentialChangeOrdersControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PotentialChangeOrdersControllerUpdateMutationResponse, ResponseErrorConfig<PotentialChangeOrdersControllerUpdate400 | PotentialChangeOrdersControllerUpdate401 | PotentialChangeOrdersControllerUpdate403 | PotentialChangeOrdersControllerUpdate404>, PotentialChangeOrdersControllerUpdateMutationRequest>({ method : "PATCH", url : getPotentialChangeOrdersControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}